import React from "react";
import { DashboardContentPage } from "components/containers/dashboard/DashboardContentTable";
import { STATISTIC_TYPES } from "./index";
import { SaleAmount } from "./detailCharts/SaleAmount";
import { TransProps } from "@lingui/react";
import { typeData } from "components/UI/BarChart/BarChart";
import { Products } from "./detailCharts/Products";

// Type
export type typeViewDataUsers = {
  variant?: string;
  title: React.ReactElement<TransProps>;
  statisticType: STATISTIC_TYPES;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  actions?: React.ReactElement;
  firstChartData: typeData;
};

// Component
export const ViewComponent: React.FC<typeViewDataUsers> = ({
  variant,
  title,
  setSidebarOpen,
  actions,
  statisticType,
}) => {
  let component;

  switch (statisticType) {
    case STATISTIC_TYPES.PRODUCT_STATISTIC:
      component = <Products variant={variant} />;
      break;
    default:
      component = <SaleAmount variant={variant} />;
  }

  return (
    <DashboardContentPage
      headerTitle={title}
      setSidebarOpen={setSidebarOpen}
      actions={actions}
      goBack={true}
    >
      {component}
    </DashboardContentPage>
  );
};
